/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
$(document).on('submit', 'form#invite_company_form', e => $('#invite_company_form').attr('action', '/workplace/tenders/' + $('#company_invitation_tender_id').val() + '/participants/invite_company'));

$(document).on('change', '#company_invitation_tender_id', () => $.ajax({
  url: "/workplace/tenders/" + $('#company_invitation_tender_id').val() + "/participants/available_company_invitation_roles",
  type: 'GET',
  data: {
    company_id: $('#company_invitation_company_id').val(),
    tender_name: $("#company_invitation_tender_id option:selected").text(),
  },
  dataType: 'script',
  beforeSend(xhr) {
    return appendLoader();
  },
  complete(xhr) {
    return destroyLoader();
  }
}));

$(document).on('click', '#add-into-list-link, #invite-in-tender-link, #company-enquiry-link, .user-tag, .user-like, #user-signin', function (e) {
  if (!jQuery.hasData($(this))) {
    e.preventDefault();
    return $('#signin-modal').foundation('reveal', 'open');
  }
});

$(document).on('click', '#user-upgrade', function (e) {
  if (!jQuery.hasData($(this))) {
    e.preventDefault();
    return $('#upgrade-modal').foundation('reveal', 'open');
  }
});

$(document).on('submit', 'form#add_company_into_list_form', function (e) {
  if ($('input[name=list_radio_button]:checked', '#add_company_into_list_form').val() === 'new') {
    return $('#list_name').val($('#new_list_name').val());
  } else {
    return $('#list_name').val($('#existing_list_name').val());
  }
});

$(document).on('change', '#list_radio_button', function (e) {
  if ($(this).val() === 'new') {
    return showExistingListDropDown(false);
  } else {
    return showExistingListDropDown(true);
  }
});

var showExistingListDropDown = function (show_existing_list) {
  if (show_existing_list === true) {
    $('#existing_list_name').show();
    $('#existing_list_name').attr('required', true).addClass('required').removeClass('optional');
    $('#existing_list_name').select2();
    $('#new_list_name').hide();
    $('#existing_list_name').attr('data-parsley-required', 'true');
    $('#new_list_name').attr('data-parsley-required', 'false');
    return $('#new_list_name').attr('required', false).addClass('optional').removeClass('required');
  } else {
    $('#existing_list_name').select2('destroy');
    $('#existing_list_name').hide();
    $('#new_list_name').show();
    $('#existing_list_name').attr('data-parsley-required', 'false');
    $('#new_list_name').attr('data-parsley-required', 'true');
    $('#new_list_name').attr('required', true).addClass('required').removeClass('optional');
    return $('#existing_list_name').attr('required', false).addClass('optional').removeClass('required');
  }
};


$(document).ready(function () {
  $('#add-company-into-list').foundation('reveal', {
    open() {
      if ($('input[name=list_radio_button]:checked', '#add_company_into_list_form').val() === 'new') {
        showExistingListDropDown(false);
        return $('.radio_buttons').hide();
      } else {
        return showExistingListDropDown(true);
      }
    }
  });
});

$('#profile-tabs').closest('.flexible-rolldown').find('a.rolldown span').html($('#profile-tabs').find('li.selected a').html());
